export default [
  {
    path: '/dashboard/cash-out-monitor',
    name: 'CashOutMonitor',
    component: () => import('./CashOutMonitor/CashOutMonitor.vue')
  }
]
